import $ from 'jquery'

import '../../../scss/app/speed_comparison.scss'

const media = {
  photos: {
    filesize: '12 MB',
    label: 'Photos',
    description: 'High Resolution',
    speeds: [
      '.05 seconds', // 2000
      '.1 seconds', // 1000
      '.2 seconds', // 500
    ],
    times: [7, 15, 300],
    scalar: 1,
  },
  music: {
    filesize: '100 MB',
    label: 'Music',
    description: 'High Quality Music File',
    speeds: ['.4 seconds', '.8 seconds', '1.6 seconds'],
    times: [200, 400, 800],
    scalar: 1,
  },
  video: {
    filesize: '2 GB',
    label: 'Video',
    description: '30 Minute Video',
    speeds: ['8 seconds', '16 seconds', '32 seconds'],
    times: [8000, 16000, 32000],
    scalar: 1,
  },
  games: {
    filesize: '100 GB',
    label: 'Games',
    description: 'Large Video Game',
    speeds: ['6 minutes 40 seconds', '13 minutes 20 seconds', '26 minutes 40 seconds'],
    times: [40000, 80000, 160000],
    scalar: 1,
  },
}

const dataTypes = ['photos', 'music', 'video', 'games']

function setLabels(speeds) {
  const _results = []
  for (let i = 0; i <= 4; i += 1) {
    _results.push($(`#speed-widget .timeline-${i} .right-label`).text(speeds[i]))
  }
  return _results
}

function animateLoadbars(times, scale) {
  const _results = []
  for (let i = 0; i <= 4; i += 1) {
    _results.push(
      $(`#speed-widget .timeline-${i} .loaderbar`).animate(
        {
          width: '100%',
        },
        times[i] * scale,
        'linear',
      ),
    )
  }
  return _results
}

$(() => {
  const $widget = $('#speed-widget')
  const $iconContainer = $widget.find('.icon-container')

  $iconContainer.mouseover((ev) => $(ev.currentTarget).addClass('mouseover'))
  $iconContainer.mouseout((ev) => $(ev.currentTarget).removeClass('mouseover'))

  $widget.find('.icon').click((ev) => {
    const type = $(ev.currentTarget).attr('data-type')
    const data = media[type]
    $widget.find('.loaderbar').clearQueue().stop().attr('style', 'width: 0%')
    $widget.find('.timelines').removeClass(dataTypes.join(' '))
    $widget.find('.timelines').addClass(type)
    $widget
      .find('.description')
      .html(`<span class='type color-${type}'>${data.label}</span> : ${data.description} (${data.filesize})`)
    setLabels(data.speeds)
    return animateLoadbars(data.times, data.scalar)
  })
})
